import { forwardRef } from "react";
import * as React from "react";
import cn from "classnames";
import { useModalContext } from "../modal-context";

export interface ModalBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  /** className to be appended to the classnames for the top level element */
  className?: string;
}

const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ children, className, ...rest }, ref) => {
    const { getBlocksWith } = useModalContext();

    return (
      <div
        className={cn(className, getBlocksWith("__body"))}
        data-auto="modal-body"
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

export default ModalBody;
